import React, {useState, useEffect, useRef} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import {Box, Typography, FormControl, OutlinedInput, InputAdornment, InputLabel, Grid, Popper , MenuItem, ImageListItem, ImageListItemBar, ImageList, CircularProgress, Select, Button, TextField, InputBase, useTheme} from "@mui/material"
import {ArrowBack, ArrowForward} from '@mui/icons-material';
import { ClickAwayListener } from '@mui/base';
import ImageIcon from '@mui/icons-material/Image';

import SearchIcon from '@mui/icons-material/Search';
import { SectionHeader } from '../common/section.header';
import { 
  getStockSearchKeyword, 
  getStockData, 
  createStock, 
  updateStock, 
  UploadAssets, 
  getPopularPexelsData, 
  getPexelsData, 
  getPopularPexelsImages,
  getPexelsImageSearch,
  getPexelsImageData,
  getPixaBayStockSearch, 
  getPopularPixaBayStockData, 
  getPopularPixabayImageStocks,
  getPixabayImageSearchStocks,
  getPixabayImageStock,
  getFreeSoundSearch,
  getFreeSoundData,
  getProjectJSON} from '../../../../axios/ApiProvider';
import { GetProjectUUID } from '../../../../assets/script/commonFunction';
import { getNewStockInformation, getThumbnailsInfo, getImageInformation, getNewAudioInformation, getNewAudioStockInformation } from '../../webGL/commonFunc';
import { VideoElements_Store, audioElements_Store, dataLoaded_Store, imageElements_Store } from '../../../../store/actions/webgldata';
import { changedJSON_Store, ProjectJSON_Store, thumbNails_Store } from '../../../../store/actions/projectdata';
import { loading_Store } from '../../../../store/actions/mainAction';
import { getMaxZIndex, changeZeroSecond } from '../../commonFunction';
import { localeForPexles, mimeTypes } from '../tooltap.config';
import { v4 as uuidv4 } from 'uuid';
import {webGlSizeOptions } from "../../../video-edit/videoEdit.config"
import pexelsVideoLogo from "../../../../assets/image/Logos/pexelVideo.png"
import pexelsImageLogo from "../../../../assets/image/Logos/pexelImage.png";
import pixabayVideoLogo from "../../../../assets/image/Logos/pixabayVideo.png";
import pixabayImageLogo from "../../../../assets/image/Logos/pixabayImage.png";
import freeSoundLogo from "../../../../assets/image/Logos/freeSound.png";
import stockLogo from "../../../../assets/image/Logos/stock_logo.png"
import { duration } from 'moment';
import { StockModal } from './stockModal';

export const PexelsImage = ({stockFilterVisibility}) => {
    const [isLoadingStock, setIsLoadingStock] = useState(true);
    const [stockData, setStockData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageTotal, setPageTotal] = useState(1);
    const [orientation, setOrientation] = useState("landscape");
    const [keywords, setKeywords] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [locale, setLocale] = useState("en-US")
    const projectUUID = GetProjectUUID();
    const thumbNails = useSelector(store => store.projectdata.thumbNails);
    const imageElements = useSelector(store => store.webgldata.imageElements);
    const Time_Count = useSelector((store) => store.videodata.Time_Count);
    const projectJSON = useSelector(store => store.projectdata.projectJSON);
    const dispatch = useDispatch()
    const [openPopper, setOpenPopper] = useState(false)
    const anchorEl = useRef(null)
  
    const [selectedStock, setSelectedStock] = useState(null);
    const [openDetaiModal, setOpenDetailModal] = useState(false);

    const imageListRef = useRef(null);
    useEffect(()=> {
      imageListRef.current.scrollTo(0, 0);
    }, [stockData]);

    const theme = useTheme();

    const handleOpenPopover = (event) => {
      setOpenPopper(true);
    };
  
    const handleClosePopover = () => {
      setOpenPopper(false);
    };
  
    useEffect(() => {
      (async function() {
        if(searchKeyword) {
          // setPageNum(1);
          const keysRes = await getStockSearchKeyword(searchKeyword);
          let respStr = "";
          keysRes.map(st => respStr += st);
          const firstBracket = respStr.indexOf("(");
          respStr = respStr.slice(firstBracket + 1).slice(0, -1);
          const respJson = JSON.parse(respStr);
          console.log('gettingISSUE', respJson.hits);
          setKeywords(respJson.hits)
        }
      })()
    }, [searchKeyword])
  
    useEffect(() => {
      getPopularPexelImageStocks();
    }, [pageNum])
  
    const getPopularPexelImageStocks = async () => {
      setIsLoadingStock(true);
      const imageRes = await getPopularPexelsImages(pageNum);
      //console.log('loaded PexelImages', imageRes);
      if(imageRes.state == "success"){
        setStockData(imageRes.data.photos);
        setPageNum(imageRes.data.page);
        setPageTotal(imageRes.data.total_results / imageRes.data.per_page);
      }
      setIsLoadingStock(false);
    }
  
    const handleChangePageNum = (e) => {
      if(e.target.value < 1 || e.target.value > pageTotal) return;
      setPageNum(e.target.value)
    }
    const handleChangeInput = (e) => {
      setSearchKeyword(e.target.value);
      if(e.target.value === ""){
        handleClosePopover();
      } else {
        handleOpenPopover(e);
      }
    }
  
    const getPexelImgSearchData = async (keyword) => {
      setIsLoadingStock(true);
      let searchedData = await getPexelsImageSearch(keyword, pageNum, locale, orientation);
      console.log("loaded Search data", searchedData);
      setStockData(searchedData.data.photos);
      setPageNum(searchedData.data.page);
      setPageTotal(searchedData.data.total_results / searchedData.data.per_page);
      setIsLoadingStock(false);
    }
  
    useEffect(() => {
      if(searchKeyword === ""){
        getPopularPexelImageStocks();
      }else{
        // if(pageNum > 1){
        //   setPageNum(1);
        // }
        getPexelImgSearchData(searchKeyword);
      }
    }, [orientation, locale])
  
    const handleStockImage = (stockItem) => {
      setSelectedStock(stockItem);
      setOpenDetailModal(true);
    }

    const addStockData = async (stockData) => {
      const newUUID = uuidv4();
      const originalFilePath = stockData.src.original;
      const originalFileName = stockData.src.original.split("/").reverse()[0];
      const mimeType = `image/${stockData.src.original.split(".").reverse()[0]}`;
      dispatch(loading_Store(true));
      let maxZIndex = getMaxZIndex(projectJSON)
      let props = [projectJSON, originalFileName, mimeType, originalFilePath, newUUID, projectUUID, 'pexelsImage']
      await getImageInformation(...props, maxZIndex, async (img, imageInfo) => {
        let imgThumbNail = [{uuid: uuidv4(), content_type: 'blob', signed_url: originalFilePath}];
        dispatch(thumbNails_Store({...thumbNails, [imageInfo.asset_uuid]: imgThumbNail}));
        let changedJSON = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
        let startTime = Time_Count.getTime();
        const imgKeys = Object.keys(projectJSON.images);
        if(imgKeys.length > 0){
          // imgGroupId = imgKeys[0];
          imgKeys.map(keyItem => {
            if(startTime < projectJSON.images[keyItem].timeline_end){
              startTime = projectJSON.images[keyItem].timeline_end;
            }
          })
        }
        imageInfo = {
          ...imageInfo,
          timeline_start: startTime,
          timeline_end: imageInfo.duration + startTime
        }
        changedJSON.images = {
          [newUUID]: imageInfo
        }
  
        dispatch(imageElements_Store({...imageElements, [newUUID]: img}));
        dispatch(changedJSON_Store(changedJSON));
        changeZeroSecond(imageInfo, dispatch);
        dispatch(loading_Store(false));
      }, async (assetUUID, newAssets) => {
        let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} };
        const JSONdata = await getProjectJSON(projectUUID);
        const projectData = JSONdata?.data[projectUUID];
  
        if(JSONdata.state !== 'success'){
          changedData = { ...changedData, asset: { ...newAssets } };
        }else{
          changedData = { ...changedData, asset: projectData.asset };
        }
        
        // dispatch(changedJSON_Store(changedData));

        
      }, () => {dispatch(dataLoaded_Store(true))})
  
    }
    const handleKeyUp = (e) => {
      if(e.keyCode === 13) {
        getPexelImgSearchData(searchKeyword);
        handleClosePopover();
      }
    }
    const handleClickKeyword =  (keyword) => {
      setSearchKeyword(keyword);
      getPexelImgSearchData(keyword);
      handleClosePopover();
    }
    return (
      <>
        <Grid container sx={{p: 1}} className='stock-filter-wrapper'>
          <Grid container sx={{ position: "relative" }}>
            <Grid container display={stockFilterVisibility} justifyContent={'center'} className='stock-filter' >
              <Grid item padding={1}>
                <FormControl fullWidth>
                  <InputLabel id='pexelImg-orientation'>Orientation</InputLabel>
                  <Select
                    labelId='pexelImg-orientation'
                    id="pexelImg-orientation-select"
                    value={orientation}
                    label="Orientation"
                    onChange={(e) => { setOrientation(e.target.value) }}
                  >
                    <MenuItem value="landscape">Landscape</MenuItem>
                    <MenuItem value="portrait">Portrait</MenuItem>
                    <MenuItem value="square">Square</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item padding={1}>
                <FormControl fullWidth>
                  <InputLabel id="pexelImg-locale">Locale</InputLabel>
                  <Select
                    labelId='pexelImg-locale'
                    id="pexelImg-locale-select"
                    value={locale}
                    label="Locale"
                    onChange={(e) => { setLocale(e.target.value) }}
                  >
                    {localeForPexles.map((lo, index) => <MenuItem value={lo} key={index}>{lo}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} paddingY={0.4}>
            <FormControl fullWidth ref={anchorEl}>
              <InputLabel htmlFor="outlined-pexelImg-search">Search</InputLabel>
              <OutlinedInput 
                id="outlined-pexelImg-search"
                startAdornment={<InputAdornment position='start'><SearchIcon /></InputAdornment>}
                label="Search"
                onChange={handleChangeInput}
                onKeyUp={handleKeyUp}
                value={searchKeyword}
              />
            </FormControl>
          </Grid>
         
          <Grid item xs={12} >
            <Box display={'flex'} justifyContent={"center"}>
              <Button
                variant='contained'
                startIcon={<ArrowBack />}
                sx={{ marginRight: "10px" }}
                onClick={() => {
                  if (pageNum === 1) return;
                  setPageNum(Number(pageNum) - 1);
                }}
                disabled={pageNum === 1}
              >
                Prev
              </Button>
              {/* <input 
                type='number'
                max={pageTotal}
                style={{width: "50px"}}
                className='stock-page-input'
                value={pageNum}
                onChange={handleChangePageNum}
              />
              <span style={{fontSize: "20px"}}>/{pageTotal}</span> */
              }
              <Button
                variant='contained'
                endIcon={<ArrowForward />}
                sx={{ marginLeft: "10px" }}
                onClick={() => {
                  if (pageNum == pageTotal) return;
                  setPageNum(Number(pageNum) + 1);
                }}
                disabled={pageNum === pageTotal}
              >Next</Button>
            </Box>
          </Grid>
         
          <ClickAwayListener onClickAway={handleClosePopover}>
            <Popper
              open={openPopper}
              anchorEl={anchorEl.current}
              sx={{
                width: `${anchorEl?.current?.clientWidth}px`,
                border: "solid 1px #e5e7eb",
                zIndex: 1000,
                backgroundColor: "#FFF"
              }}
              placement="bottom-start"
            >
              {keywords.map(w => <MenuItem key={w.objectID}
                onClick={() =>{ handleClickKeyword(w.term)}}
              >{w.term}</MenuItem>)}
            </Popper>
          </ClickAwayListener>
        </Grid>
        <Grid container sx={{overflow: "auto", position: "relative", scrollBehavior: 'smooth'}} ref={imageListRef}>
          <Grid item xs={12} sx={{position: "relative", minHeight: "300px"}}>
            <ImageList variant='masonry' cols={2} gap={8}>
              {stockData.map(sImgData => {
                let subtitle = ""
                subtitle = ` ${sImgData.width} X ${sImgData.height}`;
                return (
                  <ImageListItem key={sImgData.id} sx={{cursor: "pointer"}} 
                    onClick={() => {handleStockImage(sImgData)}}
                  >
                    <img 
                      src={`${sImgData.src.tiny}`}
                      alt={sImgData.alt}
                      loading="lazy"
                      style={{
                        minWidth: "184px",
                        minHeight: "103px",
                        flexGrow: "unset",
                        opacity: 0,
                        transition: "opacity 0.5s ease-in-out",
                      }}
                      onLoad={(e) => e.target.style.opacity = 1}
                    />
                    <ImageListItemBar 
                      subtitle={<><ImageIcon />{subtitle}</>}
                    />
                  </ImageListItem>
                )
              })}
            </ImageList>
          </Grid>
          {isLoadingStock && <Box sx={{position: "absolute", top: 0,  background: "rgba(0,0,0,0)", display: "flex", zIndex: 100000, flexDirection: "column", justifyContent: "center", height: "300px", width: "100%"}}>
              <Box sx={{ display: 'flex', position: "absolute", justifyContent: "center", width: "100%" }}>
                <CircularProgress />
              </Box>
            </Box>}
        </Grid>
        <StockModal 
            open={openDetaiModal} 
            setOpen={setOpenDetailModal} 
            stockType='pexelsImage'
            stockData={selectedStock}
            addStockData={addStockData}
            />
      </>
    )
  }